<template>
  <ul>
    <menu-options-item close label="Abrir" @click="$emit('abrir')" icon="folder-open" />
    <menu-options-item close label="Deletar" @click="$emit('deletar')" icon="times" />
  </ul>
</template>

<script>
import MenuOptionsItem from '../../../layout/context-menu/context-window-options-item'
export default {
  name: 'patio-list-menu',
  props: ['patio'],
  components: {MenuOptionsItem}
}
</script>
